import grapesjs from 'drapcode-builder';
import loadTraits from './traits';
import loadDataGroupTraits from './dataGroupCollectionTraits';
import loadBrowserStorageSetter from './browserStorageSetterCollection';
import loadCollectionFormTraits from './collectionFormTraits';
import loadAddToRemoveFromCollectionTraits from './addToRemoveFromCollectionTraits';
import loadAutoCompleteCollectionTraits from './autoCompleteCollectionTraits';

export default grapesjs.plugins.add('webconnect-collection-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'webconnect-link',
      label: false,
    },
    text: {
      type: 'webconnect-text',
      label: false,
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
  loadDataGroupTraits(editor, options);
  loadBrowserStorageSetter(editor, options);
  loadAddToRemoveFromCollectionTraits(editor, options);
  loadCollectionFormTraits(editor, options);
  loadAutoCompleteCollectionTraits(editor, options);
});
